// extracted by mini-css-extract-plugin
module.exports = {"main-component":"selectedTaskCheckBoxPopUp_main-component__13L5q"};